import type { EventParams } from '@alice-health/observability/src/lib/types'

import {
  AccreditedEstablishmentsCode,
  Context,
  DataConfirmationCode,
  ExperimentCode,
  FeatureFlagCode,
  SimulationResultCode,
  SimulatorCode,
  TestCode
} from './observability.constants'
import { observability } from './observability.setup'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface Data extends Record<string, any | undefined> {
  context: Context
  code:
    | TestCode
    | AccreditedEstablishmentsCode
    | ExperimentCode
    | FeatureFlagCode
    | SimulationResultCode
    | SimulatorCode
    | DataConfirmationCode
  message?: string
}
interface AddErrorProps {
  error?: Error
  data?: Data
}

interface LoggerProps {
  message: string
  data?: Data
  error?: Error
}

const serializeError = (error?: Error) =>
  error
    ? {
        message: error.message,
        name: error.name,
        stack: error.stack
      }
    : undefined

const addError = ({ error, data }: AddErrorProps) => {
  observability?.log(
    error?.message ?? data?.message ?? 'unknown_error',
    {
      ...data,
      error: serializeError(error)
    } as EventParams,
    { logLevel: 'ERROR' }
  )
}

const logInfo = ({ message, data, error }: LoggerProps) => {
  observability?.log(message, {
    ...data,
    error: serializeError(error)
  } as EventParams)
}

const logError = ({ message, data, error }: LoggerProps) => {
  observability?.log(
    message,
    {
      ...data,
      error: serializeError(error)
    } as EventParams,
    { logLevel: 'ERROR' }
  )
}

export { addError, logInfo, logError }

export type { Data, AddErrorProps, LoggerProps }
